(() => {
  if (window.MOTShopLookLoaded) return;
  window.MOTShopLookLoaded = true;
  const roots = new WeakSet();
  const cards = new WeakSet();
  const variantMaps = new WeakMap();
  const selectedVariant = (card) => card.querySelector('[data-look-variant]')?.value || card.querySelector('[data-look-add]')?.dataset.variantId || card.dataset.selectedVariant;
  const variantMap = (card) => {
    if (!variantMaps.has(card)) {
      try { variantMaps.set(card, JSON.parse(card.querySelector('[data-look-variants]').textContent)); }
      catch (_) { variantMaps.set(card, {}); }
    }
    return variantMaps.get(card);
  };
  const renderVariant = (card, id) => {
    const variant = variantMap(card)[id];
    if (!variant) return;
    const root = card.closest('[data-shop-look]');
    card.dataset.selectedVariant = id;
    card.querySelector('[data-look-price]').textContent = variant.price;
    card.querySelector('[data-look-stock]').textContent = variant.available && variant.preorder ? variant.stock : '';
    card.querySelectorAll('[data-look-link]').forEach(link => link.href = variant.url);
    const image = card.querySelector('.mot-look-card__image img');
    if (image && image.getAttribute('src') !== variant.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = variant.image;
    }
    const button = card.querySelector('[data-look-add]');
    if (button) {
      button.dataset.variantId = id;
      button.disabled = !variant.available;
      button.textContent = !variant.available ? root.dataset.soldOut : variant.preorder ? root.dataset.preorder : root.dataset.add;
    }
    const startingLabel = card.querySelector('[data-look-starting-label]');
    if (startingLabel) startingLabel.textContent = variant.option1;
  };
  const renderArrows = (root) => {
    const track = root.querySelector('[data-look-track]');
    const maximum = track.scrollWidth - track.clientWidth;
    root.querySelector('[data-look-direction="-1"]').disabled = track.scrollLeft <= 2;
    root.querySelector('[data-look-direction="1"]').disabled = track.scrollLeft >= maximum - 2;
  };
  const resize = new ResizeObserver(entries => entries.forEach(entry => renderArrows(entry.target.closest('[data-shop-look]'))));
  const initialise = () => {
    document.querySelectorAll('[data-shop-look]').forEach(root => {
      if (!roots.has(root)) {
        roots.add(root);
        const track = root.querySelector('[data-look-track]');
        resize.observe(track);
        track.addEventListener('scroll', () => renderArrows(root), { passive: true });
      }
      root.querySelectorAll('[data-look-card]').forEach(card => {
        if (!cards.has(card)) {
          cards.add(card);
          renderVariant(card, selectedVariant(card));
        }
      });
      renderArrows(root);
    });
  };
  const addPiece = async (button) => {
    const card = button.closest('[data-look-card]');
    const root = card.closest('[data-shop-look]');
    const id = button.dataset.variantId;
    const variant = variantMap(card)[id];
    if (!variant?.available || button.disabled) return;
    const feedback = card.querySelector('[data-look-feedback]');
    const select = card.querySelector('[data-look-variant]');
    button.disabled = true;
    if (select) select.disabled = true;
    button.textContent = root.dataset.adding;
    feedback.textContent = '';
    const data = new FormData();
    data.append('id', id);
    data.append('quantity', '1');
    data.append('sections', 'cart-items,cart-footer,cart-item-count');
    data.append('sections_url', location.pathname);
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: data
      });
      const responseText = await response.text();
      let result = {};
      try { result = responseText ? JSON.parse(responseText) : {}; } catch (_) {}
      if (!response.ok) throw new Error(result.description || result.message || root.dataset.error);
      feedback.textContent = root.dataset.added;
      document.body.dispatchEvent(new CustomEvent('baseline:cart:afteradditem', { bubbles: true, detail: { response: result, sourceId: 'mot-shop-look' } }));
    } catch (error) {
      feedback.textContent = error.message || root.dataset.error;
    } finally {
      if (select) select.disabled = false;
      renderVariant(card, id);
    }
  };
  document.addEventListener('theme:variant:change', event => {
    const { product, variant } = event.detail || {};
    if (!product?.id || !variant?.id) return;
    document.querySelectorAll('[data-shop-look]').forEach(root => {
      if (root.dataset.currentProduct !== String(product.id)) return;
      let images;
      try { images = JSON.parse(root.querySelector('[data-look-starting-variants]').textContent); }
      catch (_) { return; }
      const next = images[variant.id];
      const image = root.querySelector('.mot-look__hero img');
      if (!next?.image || !image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = next.image;
      image.alt = next.alt;
    });
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-look-variant]');
    if (select) renderVariant(select.closest('[data-look-card]'), select.value);
  });
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-look-direction]');
    if (arrow && !arrow.disabled) {
      const root = arrow.closest('[data-shop-look]');
      const track = root.querySelector('[data-look-track]');
      track.scrollBy({ left: Number(arrow.dataset.lookDirection) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    const cancel = event.target.closest('[data-look-cancel-preorder]');
    if (cancel) cancel.closest('dialog').close();
    const confirm = event.target.closest('[data-look-confirm-preorder]');
    if (confirm) {
      const dialog = confirm.closest('dialog');
      const pending = dialog.pendingButton;
      dialog.close();
      if (pending) addPiece(pending);
    }
    const button = event.target.closest('[data-look-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const card = button.closest('[data-look-card]');
    const variant = variantMap(card)[button.dataset.variantId];
    if (variant?.preorder) {
      const dialog = card.closest('[data-shop-look]').querySelector('[data-look-preorder-dialog]');
      dialog.querySelector('[data-look-preorder-message]').textContent = variant.stock;
      dialog.pendingButton = button;
      dialog.showModal();
    } else addPiece(button);
  });
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('DOMContentLoaded', initialise);
  initialise();
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-shop-look]') || node.querySelector?.('[data-shop-look]'))))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; initialise(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
